(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ScoresController = (function(superClass) {
    extend(ScoresController, superClass);

    function ScoresController(scope, transitions, service, state, http, transition$) {
      var ref;
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.state = state;
      this.http = http;
      this.transition$ = transition$;
      this.close = bind(this.close, this);
      this.updateChartData = bind(this.updateChartData, this);
      this.hasData = bind(this.hasData, this);
      this.updateScores = bind(this.updateScores, this);
      ScoresController.__super__.constructor.apply(this, arguments);
      this.scope.fullpage = true;
      this.scope.dataLoaded = false;
      this.scope.close = this.close;
      this.scope.source = {
        selection: null
      };
      this.scope.updateChartData = this.updateChartData;
      this.scope.hasData = this.hasData;
      this.scope.service = this.service;
      this.scope.labels = [];
      this.sourceData = [];
      this.scope.data = [];
      this.scope.colors = [];
      this.scope.series = [];
      this.scope.options = {
        responsive: false,
        layout: {
          padding: 15
        },
        animation: {
          duration: 0
        },
        scale: {
          pointLabels: {
            fontSize: 14
          },
          ticks: {
            min: 0,
            max: 100,
            stepSize: 20
          }
        },
        tooltips: {
          filter: function(entry) {
            return entry.yLabel;
          }
        }
      };
      this.scope.displayMode = {
        state: false,
        national: false
      };
      this.scope.$on('fieldprintChanged', (function(_this) {
        return function(event, fpcResult) {
          if (fpcResult.id === _this.transition$.params().id) {
            return _this.updateScores(fpcResult);
          }
        };
      })(this));
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          _this.scope.dataLoaded = true;
          _this.scope.source.selection = _this.service.fpcResult.data.irrigated ? 'irrigated' : 'dryland';
          return _this.updateScores(_this.service.fpcResult);
        };
      })(this));
      if (((ref = this.service.fpcResult) != null ? ref.id : void 0) !== this.transition$.params().id) {
        this.service.reset();
        this.service.loadFieldprint(this.transition$.params().id);
      }
    }

    ScoresController.prototype.updateScores = function(fpcResult) {
      var prepareForPresentation, ref, ref1;
      prepareForPresentation = (function(_this) {
        return function(scores) {
          return scores.map(function(score) {
            if (score) {
              return score.toFixed(1);
            } else {
              return null;
            }
          });
        };
      })(this);
      this.service.fpcResult = fpcResult;
      this.sourceData['dryland'] = (ref = fpcResult.dryland_scores) != null ? ref.map(prepareForPresentation) : void 0;
      this.sourceData['irrigated'] = (ref1 = fpcResult.irrigated_scores) != null ? ref1.map(prepareForPresentation) : void 0;
      return this.scope.updateChartData();
    };

    ScoresController.prototype.hasData = function(type) {
      var ref;
      return ((ref = this.sourceData[type]) != null ? ref.length : void 0) > 0;
    };

    ScoresController.prototype.updateChartData = function() {
      var sourceData;
      this.scope.data = [];
      sourceData = angular.copy(this.sourceData[this.scope.source.selection]);
      if (!(sourceData != null ? sourceData.length : void 0)) {
        return;
      }
      this.scope.labels = ['Land Use', ['Soil', 'Conservation'], ['Soil', 'Carbon'], ['Irrigation', 'Water Use'], ['Energy', 'Use'], ['Greenhouse Gas', 'Emissions'], ['Water', 'Quality'], ['Biodiversity']];
      sourceData.map(function(data) {
        var soilCarbon;
        soilCarbon = data[5];
        data[5] = data[3];
        data[3] = data[2];
        return data[2] = soilCarbon;
      });
      if (this.scope.source.selection === 'dryland') {
        this.scope.labels.splice(3, 1);
        sourceData[0].splice(3, 1);
        sourceData[1].splice(3, 1);
        sourceData[2].splice(3, 1);
      }
      this.scope.data = [sourceData[0]];
      this.scope.colors = ["rgb(0,161,38)"];
      this.scope.series = ['You'];
      this.scope.datasetOverride = [
        {
          backgroundColor: "rgba(0,161,38,.5)",
          pointStyle: 'circle',
          pointBorderColor: 'rgb(0,161,38)',
          pointBorderWidth: 1
        }
      ];
      if (this.scope.displayMode.state) {
        this.scope.data.push(sourceData[1]);
        this.scope.colors.push("rgb(0,85,204)");
        this.scope.series.push('State Benchmark');
        this.scope.datasetOverride.push({
          fill: false,
          borderColor: 'rgba(0,0,0,0)',
          pointStyle: 'circle',
          pointBorderColor: 'rgb(0,85,204)',
          pointBorderWidth: 3
        });
      }
      if (this.scope.displayMode.national) {
        this.scope.data.push(sourceData[2]);
        this.scope.colors.push("rgb(248,148,6)");
        this.scope.series.push('National Benchmark');
        return this.scope.datasetOverride.push({
          fill: false,
          borderColor: 'rgba(0,0,0,0)',
          pointStyle: 'circle',
          pointBorderColor: 'rgb(248,148,6)',
          pointBorderWidth: 5
        });
      }
    };

    ScoresController.prototype.close = function() {
      return this.state.go('^');
    };

    return ScoresController;

  })(Controller);

}).call(this);
